<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
import { useRegisterValidation } from "@/components/EditorValidator";

const emitFn = defineEmits<CommonEditControlEmits>();

const props = defineProps<EditControlProps>();

let list: any = [];
let selectedIndex: number = -1;
let aicMode: boolean = true;
let text = ref<string>("");
let error: boolean = false;

const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
var uiData = reactive(ui);

config.validate = validate; // default validation funktion mit unserer von dem control überschreiben.
useRegisterValidation({ config });

const uidata = reactive<EditorControlUiData>(uiData);
onMounted(() => {
  mounted(uiData, props, config);
  const initValue = config.initValue;
  if (config.column?.meta.combo) {
    for (let i = 0; i < config.column.meta.combo.length; i++) {
      const entry = config.column.meta.combo[i];
      if (typeof entry === "object") {
        list.push(entry);
        aicMode = true;
        if (initValue && initValue.aic === entry.aic) {
          selectedIndex = i;
        }
      } else {
        list.push({ aic: entry, bezeichnung: entry });
        aicMode = false;
        if (initValue && initValue === entry) {
          selectedIndex = i;
        }
      }
    }
  }
  // valueChanged("", true);
});
function textChanged() {
  valueChanged(config, uidata, text);
}
function validate() {
  if (uidata.required) {
    if (uidata.data) {
      return true;
    }
    uidata.errorText = config.requiredMessage;
    error = true;
    return false;
  }

  return true;
}
</script>
<template>
  <div class="wrap" v-if="uidata.showMutable">
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-radio-group
          v-if="!uidata.disabled"
          v-bind="props"
          inline
          @update:modelValue="textChanged"
          :error="error"
          :error-messages="uidata.errorText"
          v-model="uidata.data"
          :label="uidata.description"
          color="warning"
          persistent-hint
        >
          <v-radio
            v-for="(val, ix) in list"
            :key="'rb' + ix"
            :label="val.bezeichnung"
            :value="val"
            color="primary"
            hide-details
            :required="uidata.required"
          ></v-radio>
        </v-radio-group>

        <div style="text-align: left" v-if="uidata.disabled">
          <span>{{ uidata.description }}: {{ list.bezeichnung }}</span>
        </div>
        <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        />
      </template>
    </v-tooltip>
  </div>
</template>
<style lang="scss" scoped>
.e-radio-wrapper {
  display: inline-block;
  line-height: 1;
  padding-left: 10px;
}
</style>
